import React from 'react';
import { Form, Input} from 'antd';
import Editor from 'for-editor'
const EditorToolbar = {
    h1: false, 
    h2: true, 
    h3: true, 
    h4: true, 
    h5: true, 
    img: false, 
    link: true, 
    code: false, 
    preview: true, 
    expand: true, 
    /* v0.0.9 */
    undo: true, 
    redo: true, 
    save: false, 
    /* v0.2.3 */
    subfield: true,
  }
  
const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};

class FormInputTextArea extends React.Component {

    render(){
        const field = this.props.field ? this.props.field : 'meta_description';
        const label = this.props.label ? this.props.label : field;
        const required = this.props.required === undefined ? true : this.props.required;
        const textSize = this.props.textSize ? this.props.textSize : 5;
        return (
        <Form.Item
            {...formItemLayout}
            label={label}
            colon={false}>
            {this.props.getFieldDecorator(field, {
                initialValue: this.props.initialValue,
                rules: [{
                    required: required, message: 'فیلد را پر کنید',
                }],
            })(
                <Editor rows={textSize} toolbar={EditorToolbar}  onChange={(e)=>{this.props.update(e, field)}}/>
            )}
        </Form.Item>
        );
    }
}

export default FormInputTextArea;


// WEBPACK FOOTER //
// ./src/containers/Pages/Partials/FormInputTextArea.js